function Selector(selector, callback = null) {
    // Getting pre selected item
    this.selectors = selector && selector.length ? selector : [selector];

    // If id or class is present
    if (typeof selector === 'string') {
        // Getting selectors
        this.selectors = document.querySelectorAll(selector);
    }

    // Method to run call back on selectors
    this.command = (callback) => {
        return this.selectors.forEach(function (x, i){
            callback(x, i);
        });
    };

    // If callback exist
    if (callback) this.command(callback);

    // Helper method to add class
    this.addClass = (className) => {
        this.command((x) => {
            x.classList.add(className);
        });
    };

    // Helper method to remove class
    this.removeClass = (className) => {
        this.command((x) => {
            x.classList.remove(className);
        });
    };

    // Helper method to show elements
    this.show = () => {
        this.command((x) => {
            x.style.display = 'block';
        });
    }

    // Helper method to hide elements
    this.hide = () => {
        this.command((x) => {
            x.style.display = 'none';
        });
    }

    // Return Instance
    return this;
}

// Exporting selector
export const $ = (x, cb = null) => new Selector(x, cb);
